var map = {
	"./font/HalvarBreit-Bd.ttf": 7902,
	"./font/HalvarBreit-BdSlanted.ttf": 9813,
	"./font/HalvarBreit-BdSuSlanted.ttf": 3967,
	"./font/HalvarBreit-Blk.ttf": 9194,
	"./font/HalvarBreit-BlkSlanted.ttf": 7425,
	"./font/HalvarBreit-BlkSuSlanted.ttf": 9111,
	"./font/HalvarBreit-Hl.ttf": 4912,
	"./font/HalvarBreit-HlSlanted.ttf": 8875,
	"./font/HalvarBreit-HlSuSlanted.ttf": 5984,
	"./font/HalvarBreit-Hl_1.ttf": 8346,
	"./font/HalvarBreit-Lt.ttf": 6442,
	"./font/HalvarBreit-LtSlanted.ttf": 2441,
	"./font/HalvarBreit-LtSuSlanted.ttf": 3766,
	"./font/HalvarBreit-Md.ttf": 1198,
	"./font/HalvarBreit-MdSlanted.ttf": 5263,
	"./font/HalvarBreit-MdSuSlanted.ttf": 9149,
	"./font/HalvarBreit-Rg.ttf": 1458,
	"./font/HalvarBreit-RgSlanted.ttf": 2613,
	"./font/HalvarBreit-RgSuSlanted.ttf": 2619,
	"./font/HalvarBreit-Th.ttf": 9343,
	"./font/HalvarBreit-ThSlanted.ttf": 47,
	"./font/HalvarBreit-ThSuSlanted.ttf": 4496,
	"./font/HalvarBreit-XBd.ttf": 7896,
	"./font/HalvarBreit-XBdSlanted.ttf": 5059,
	"./font/HalvarBreit-XBdSuSlanted.ttf": 7044,
	"./font/HalvarBreit-XTh.ttf": 5199,
	"./font/HalvarBreit-XThSlanted.ttf": 102,
	"./font/HalvarBreit-XThSuSlanted.ttf": 9333,
	"./font/new_font/AlfaSlabOne-Regular.ttf": 5501,
	"./font/new_font/Arial Rounded Bold.ttf": 2308,
	"./font/new_font/BebasNeue-Regular.ttf": 1406,
	"./font/new_font/LuckiestGuy-Regular.ttf": 8721,
	"./font/new_font/Midorima-PersonalUse-Regular.ttf": 4867,
	"./font/new_font/Montserrat/Montserrat-BlackItalic.ttf": 9005,
	"./font/new_font/Montserrat/Montserrat-Bold.ttf": 4376,
	"./font/new_font/Montserrat/Montserrat-BoldItalic.ttf": 1376,
	"./font/new_font/Montserrat/Montserrat-ExtraBold.ttf": 5832,
	"./font/new_font/Montserrat/Montserrat-ExtraBoldItalic.ttf": 4669,
	"./font/new_font/Montserrat/Montserrat-ExtraLight.ttf": 6531,
	"./font/new_font/Montserrat/Montserrat-ExtraLightItalic.ttf": 7822,
	"./font/new_font/Montserrat/Montserrat-Italic.ttf": 7105,
	"./font/new_font/Montserrat/Montserrat-Light.ttf": 6868,
	"./font/new_font/Montserrat/Montserrat-LightItalic.ttf": 4794,
	"./font/new_font/Montserrat/Montserrat-Medium.ttf": 1518,
	"./font/new_font/Montserrat/Montserrat-MediumItalic.ttf": 8922,
	"./font/new_font/Montserrat/Montserrat-Regular.ttf": 3642,
	"./font/new_font/Montserrat/Montserrat-SemiBold.ttf": 5689,
	"./font/new_font/Montserrat/Montserrat-SemiBoldItalic.ttf": 815,
	"./font/new_font/Montserrat/Montserrat-Thin.ttf": 8183,
	"./font/new_font/Montserrat/Montserrat-ThinItalic.ttf": 5352,
	"./font/new_font/foo.otf": 2020,
	"./images/bold.png": 3563,
	"./images/caps.png": 5117,
	"./images/center.png": 1922,
	"./images/center_active.png": 4168,
	"./images/italic.png": 5110,
	"./images/leftSide.png": 9238,
	"./images/leftSide_active.png": 8515,
	"./images/logo.png": 4427,
	"./images/refresh-page-option.png": 7420,
	"./images/rightSide.png": 6517,
	"./images/rightSide_active.png": 3779,
	"./images/templateNull.png": 5642,
	"./images/type_boxes.png": 2785,
	"./images/type_cleaner.png": 8519,
	"./images/type_slots.jpeg": 1358,
	"./images/type_wheel.png": 8227,
	"./images/underline.png": 1218,
	"./imagesWheel/10_12.png": 6648,
	"./imagesWheel/10_6.png": 926,
	"./imagesWheel/10_8.png": 9156,
	"./imagesWheel/11_12.png": 7990,
	"./imagesWheel/11_6.png": 6215,
	"./imagesWheel/11_8.png": 6996,
	"./imagesWheel/12_12.png": 7427,
	"./imagesWheel/12_6.png": 6727,
	"./imagesWheel/12_8.png": 5062,
	"./imagesWheel/13_12.png": 5796,
	"./imagesWheel/13_6.png": 7127,
	"./imagesWheel/13_8.png": 5032,
	"./imagesWheel/14_12.png": 7391,
	"./imagesWheel/14_6.png": 391,
	"./imagesWheel/14_8.png": 3607,
	"./imagesWheel/15_12.png": 1630,
	"./imagesWheel/15_6.png": 345,
	"./imagesWheel/15_8.png": 5075,
	"./imagesWheel/16_12.png": 2386,
	"./imagesWheel/16_6.png": 6011,
	"./imagesWheel/16_8.png": 1379,
	"./imagesWheel/17_12.png": 4981,
	"./imagesWheel/17_6.png": 1055,
	"./imagesWheel/17_8.png": 8740,
	"./imagesWheel/18_12.png": 7805,
	"./imagesWheel/18_6.png": 1431,
	"./imagesWheel/18_8.png": 854,
	"./imagesWheel/19_12.png": 9949,
	"./imagesWheel/19_6.png": 9591,
	"./imagesWheel/19_8.png": 2251,
	"./imagesWheel/1_12.png": 5551,
	"./imagesWheel/1_6.png": 4351,
	"./imagesWheel/1_8.png": 5411,
	"./imagesWheel/20_12.png": 3606,
	"./imagesWheel/20_6.png": 3215,
	"./imagesWheel/20_8.png": 9463,
	"./imagesWheel/21_12.png": 4718,
	"./imagesWheel/21_6.png": 7177,
	"./imagesWheel/21_8.png": 7568,
	"./imagesWheel/22_12.png": 7470,
	"./imagesWheel/22_6.png": 7680,
	"./imagesWheel/22_8.png": 8814,
	"./imagesWheel/23_12.png": 1408,
	"./imagesWheel/23_6.png": 7235,
	"./imagesWheel/23_8.png": 2906,
	"./imagesWheel/24_12.png": 2091,
	"./imagesWheel/24_6.png": 4879,
	"./imagesWheel/24_8.png": 3016,
	"./imagesWheel/25_12.png": 6684,
	"./imagesWheel/25_6.png": 3213,
	"./imagesWheel/25_8.png": 8237,
	"./imagesWheel/26_12.png": 9639,
	"./imagesWheel/26_6.png": 9097,
	"./imagesWheel/26_8.png": 805,
	"./imagesWheel/27_12.png": 3175,
	"./imagesWheel/27_6.png": 6120,
	"./imagesWheel/27_8.png": 824,
	"./imagesWheel/28_12.png": 2061,
	"./imagesWheel/28_6.png": 54,
	"./imagesWheel/28_8.png": 3144,
	"./imagesWheel/29_12.png": 5482,
	"./imagesWheel/29_6.png": 6262,
	"./imagesWheel/29_8.png": 8569,
	"./imagesWheel/2_12.png": 1396,
	"./imagesWheel/2_6.png": 3430,
	"./imagesWheel/2_8.png": 3219,
	"./imagesWheel/30_12.png": 8450,
	"./imagesWheel/30_6.png": 1696,
	"./imagesWheel/30_8.png": 4027,
	"./imagesWheel/31_12.png": 5273,
	"./imagesWheel/31_6.png": 3688,
	"./imagesWheel/31_8.png": 6454,
	"./imagesWheel/32_12.png": 3710,
	"./imagesWheel/32_6.png": 7771,
	"./imagesWheel/32_8.png": 7578,
	"./imagesWheel/3_12.png": 7580,
	"./imagesWheel/3_6.png": 3610,
	"./imagesWheel/3_8.png": 8630,
	"./imagesWheel/4_12.png": 5585,
	"./imagesWheel/4_6.png": 3825,
	"./imagesWheel/4_8.png": 1316,
	"./imagesWheel/5_12.png": 5511,
	"./imagesWheel/5_6.png": 9805,
	"./imagesWheel/5_8.png": 1304,
	"./imagesWheel/6_12.png": 8185,
	"./imagesWheel/6_6.png": 7809,
	"./imagesWheel/6_8.png": 844,
	"./imagesWheel/7_12.png": 7108,
	"./imagesWheel/7_6.png": 3995,
	"./imagesWheel/7_8.png": 6843,
	"./imagesWheel/8_12.png": 8126,
	"./imagesWheel/8_6.png": 6617,
	"./imagesWheel/8_8.png": 3276,
	"./imagesWheel/9_12.png": 2998,
	"./imagesWheel/9_6.png": 5291,
	"./imagesWheel/9_8.png": 8570,
	"./images_module/typeLand/egypt/12_section.png": 3588,
	"./images_module/typeLand/egypt/16_section.png": 9799,
	"./images_module/typeLand/egypt/6_section.png": 1410,
	"./images_module/typeLand/egypt/8_section.png": 7909,
	"./style/AppStyle.scss": 6026,
	"./style/PaginationStyle.scss": 5844,
	"./topicLandPreview/BonanzaPreview/BonanzePreview_1.png": 698,
	"./topicLandPreview/BonanzaPreview/BonanzePreview_2.png": 9903,
	"./topicLandPreview/DimondFruitsPreview/DimondFriutsPreview_1.png": 5970,
	"./topicLandPreview/DimondFruitsPreview/DimondFriutsPreview_2.png": 4260,
	"./topicLandPreview/DimondFruitsPreview/DimondFriutsPreview_3.png": 5484,
	"./topicLandPreview/EgyptImagePreview/PreviewEgypt_1.png": 8978,
	"./topicLandPreview/EgyptImagePreview/PreviewEgypt_2.png": 2988,
	"./topicLandPreview/EgyptImagePreview/PreviewEgypt_3.png": 1975,
	"./topicLandPreview/EgyptImagePreview/PreviewEgypt_4.png": 7984,
	"./topicLandPreview/EgyptImagePreview/PreviewEgypt_5.png": 4122,
	"./topicLandPreview/EgyptImagePreview/PreviewEgypt_6.png": 8509,
	"./topicLandPreview/JokerPreview/JokerPreview_1.png": 3590,
	"./topicLandPreview/JokerPreview/JokerPreview_2.png": 3103,
	"./topicLandPreview/JokerPreview/JokerPreview_3.png": 1801,
	"./topicLandPreview/JokerPreview/JokerPreview_4.png": 3012,
	"./topicLandPreview/JunglePreview/JunglePreview_1.png": 2757,
	"./topicLandPreview/JunglePreview/JunglePreview_2.png": 6237,
	"./topicLandPreview/JunglePreview/JunglePreview_3.png": 3163,
	"./topicLandPreview/JunglePreview/JunglePreview_4.png": 4437,
	"./topicLandPreview/JunglePreview/JunglePreview_5.png": 4680,
	"./topicLandPreview/KokokoPreview/KokokoPreview_1.png": 9151,
	"./topicLandPreview/LeprechaunsPreview/LeprechaunsPreview_1.png": 5434,
	"./topicLandPreview/LeprechaunsPreview/LeprechaunsPreview_2.png": 4868,
	"./topicLandPreview/PlinkoPreview/PlinkoPreview_1.png": 3816,
	"./topicLandPreview/SportPreview/SportPreview_1.png": 1311,
	"./topicLandPreview/SportPreview/SportPreview_2.png": 1974,
	"./topicLandPreview/SportPreview/SportPreview_3.png": 7657,
	"./topicLandPreview/Thimblespreview/ThimblesPreview_1.png": 453,
	"./topicLandPreview/TigerPreview/TigerPreview_1.png": 2565,
	"./topicLandPreview/WolfBoofaloPreview/PreviewWolfBoofalo_1.png": 3759,
	"./topicLandPreview/WolfBoofaloPreview/PreviewWolfBoofalo_2.png": 8977,
	"./topicLandPreview/WolfBoofaloPreview/PreviewWolfBoofalo_3.png": 5205,
	"./topicLandPreview/ZeusPreview/ZeusPreview_1.png": 2856,
	"./topicLandPreview/ZeusPreview/ZeusPreview_2.png": 7625,
	"./topicLandPreview/ZeusPreview/ZeusPreview_3.png": 4257
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;